<template>
  <div class=" ">
    <div v-if="router.currentRoute.value.meta.title=='首页'" >
      <el-carousel :height="ispc?'800px':'660rem'" autoplay>
        <el-carousel-item  v-for="(item,index) in banners" :key="index">
          <div class="relative  w100 h100">
            <div class="scrolsimga w100 h100 banners_images" :style="{ backgroundImage: 'url(' + baseUrls + item.images + ')' }" ></div>
            <div class="absolute bodys bannes ">
              <div class="banners_texts1 nospacings">{{ item.title }}</div>
              <div class="banners_texts2 nospacings" >{{ item.introduce }}</div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div  v-if="banners.length>0&&router.currentRoute.value.meta.title!='首页'" class="relative">
      <img class="w100 block" :src="baseUrls+banners[0].images" alt="" srcset="">
      <div class="absolute bg_0000002 at0 ar0 al0 ab0 flex flex-col-center flex-row-center">
        <div class="banners_texts nospacings">{{ banners[0].type }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, watch, computed, ref, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
const store = useStore();
const router = useRouter();
const { proxy } = getCurrentInstance(); //关键代码
const ispc = computed(() => store.state.ispc);
const baseUrls = computed(() => store.state.baseUrls);
const banners = ref([]);
watch(
  ()=>router.currentRoute.value,
  () => {
    getbanners()
  }
)
watch(
  ()=>store.state.banners,
  () => {
    getbanners()
  }
)
const getbanners=()=>{
  var type=router.currentRoute.value.meta.title
  if (
    router.currentRoute.value.query.types &&
    router.currentRoute.value.query.types == "en"
  ) {
    type="英文首页"
  }
  var list=[]
  store.state.banners.forEach(items=>{
    if(items.type==type ){
      list.push(items)
    }
  })
  banners.value=list
}

</script>

<style>

.bannes{
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
.banners_texts2::after{
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  background: #FFFFFF;
  transform: translate(0,-50%);
}
.banners_texts::after{
  content: "";
  position: absolute;
  left: 50%;
  background: #FFFFFF;
  transform: translate(-50%,0);
}
@media screen and (max-width: 768px) {
  .banners_texts1{
    font-weight: bold;
    font-size: 40rem;
    color: #FFFFFF;
    text-shadow: 0px 0px 17px rgba(64,167,246,0.65);
    margin-bottom: 20rem;
  }
  .banners_texts2{
    font-size: 26rem;
    color: #FEFEFE;
    position: relative;
    padding-left: 15rem;
  }
  .banners_texts2::after{
    width: 4rem;
    height: 40rem;
  }
  .banners_texts{
    font-weight: bold;
    font-size: 48rem;
    color: #FFFFFF;
    position: relative;
  }
  .banners_texts::after{
    bottom: -20rem;
    width: 100rem;
    height: 4rem;
  }
}
@media screen and (min-width: 768px) {
  .banners_images{
    animation: images1ani 5s;
    -webkit-animation: images1ani 5s; /* Safari 与 Chrome */
  }
  .banners_texts1{
    font-weight: bold;
    font-size: 54px;
    color: #FFFFFF;
    text-shadow: 0px 0px 17px rgba(64,167,246,0.65);
    margin-bottom: 10px;
    opacity: 1;transform: translateX(0);
    animation: texts1ani 4s;
    -webkit-animation: texts1ani 4s; /* Safari 与 Chrome */
  }
  .banners_texts2{
    font-size: 30px;
    color: #FEFEFE;
    position: relative;
    padding-left: 15px;
    opacity: 1;transform: translateX(0);
    animation: texts2ani 6s;
    -webkit-animation: texts2ani 6s; /* Safari 与 Chrome */
  }
  .banners_texts2::after{
    width: 4px;
    height: 40px;
  }

  .banners_texts{
    font-weight: bold;
    font-size: 48px;
    color: #FFFFFF;
    position: relative;
  }
  .banners_texts::after{
    bottom: -20px;
    width: 100px;
    height: 4px;
  }

}
@media screen and (min-width: 768px) and (max-width: 900px) {
}
@media screen and (min-width: 900px) and (max-width: 1200px) {
}
@media screen and (min-width: 1200px) and (max-width: 1400px) {
}
@media screen and (min-width: 1400px) and (max-width: 1700px) {
}
@media screen and (min-width: 1700px) {
}



@keyframes images1ani{
    from {transform:scale(1.35);}
    to {transform:scale(1);}
}
@-webkit-keyframes images1ani{
    from {transform:scale(1.35);}
    to {transform:scale(1);}
}
@keyframes texts1ani{
    from {opacity: 0;transform: translateY(400px);}
    to {opacity: 1;transform: translateY(0);}
}
@-webkit-keyframes texts1ani{
    from {opacity: 0;transform: translateY(400px);}
    to {opacity: 1;transform: translateY(0);}
}
@keyframes texts2ani{
    0% {opacity: 0;transform: translateX(400px);}
    60% {opacity: 0;transform: translateX(400px);}
    100% {opacity: 1;transform: translateX(0);}
}
@-webkit-keyframes texts2ani{
    0% {opacity: 0;transform: translateX(400px);}
    60% {opacity: 0;transform: translateX(400px);}
    100% {opacity: 1;transform: translateX(0);}
}
 
</style>
